import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tab,
    Tabs,
} from "@mui/material";
import LoginHistory from "../../features/manageUsers/loginHistory";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import ReferralHistory from "../../features/manageUsers/refferalHistory";
import SearchBar from "../../components/SearchBar";
import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import AdjustedPointsTable from "../../features/manageUsers/adjustedPointsTable";
import VerificationModal from "../../Modals/verificationModal";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import SwitchToggle from "../../components/SwitchToggle";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ViewDriver = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");
    const [valueTabs, setValueTabs] = useState(0);
    const [valueTabs1, setValueTabs1] = useState(0);
    const [valueTabs2, setValueTabs2] = useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs1(newValue);
    };
    const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs2(newValue);
    };

    const [status, setStatus] = useState("default");
    const handleStatusChange = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <>
            <div className="main_title">
                <h1>Driver Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-drivers")}>Manage Drivers</button>{" "}
                    - View Driver
                </p>
            </div>

            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            className="custom_tabs_links"
                        >
                            <Tab label="Personal Info" {...a11yProps(0)} />
                            <Tab label="Documents" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                </div>
            </div>

            {/* Personal Info */}
            {/* Personal Info */}
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="cards view_page">
                    <div className="table_header">
                        <h2>Personal Info</h2>

                    </div>

                    <div className="gap_p" >
                        {/* Driver Image */}
                        <div className="vew_img w_25">
                            <h6>Driver Image</h6>
                            <figure
                            >
                                <img
                                    src="/static/images/user_placeholder.png"
                                    alt="Driver"
                                />
                            </figure>
                        </div>

                        {/* Basic Info */}
                        <div className="w_100">
                            <div className="gap_p">
                                <div className="w_33">
                                    <h6>ID</h6>
                                    <p>#drv_001</p>
                                </div>

                                <div className="w_33">
                                    <h6>Name</h6>
                                    <p>Rajesh Kumar</p>
                                </div>

                                <div className="w_33">
                                    <h6>Email</h6>
                                    <p>rajesh.kumar@example.com</p>
                                </div>

                                <div className="w_33">
                                    <h6>Mobile Number</h6>
                                    <p>+91 9876543210</p>
                                </div>

                                <div className="w_33">
                                    <h6>Gender</h6>
                                    <p>Male</p>
                                </div>

                                <div className="w_33">
                                    <h6>Employment Type</h6>
                                    <p>Salaried</p>
                                </div>

                                <div className="w_33">
                                    <h6>Salary</h6>
                                    <p>$500</p>
                                </div>

                                <div className="w_33">
                                    <h6>Onboard Date</h6>
                                    <p>30 July 2025</p>
                                </div>

                                <div className="w_33">
                                    <h6>Status</h6>
                                    <SwitchToggle />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Address Details */}
                    <div className="mt_30">
                        <h4>Address Details</h4>
                        <div className="w_100">
                            <h6>Address</h6>
                            <p>
                                C-127, Phase-8, Industrial Area, Sector 73, Sahibzada Ajit Singh Nagar,
                                Punjab 160071
                            </p>
                        </div>
                    </div>

                    {/* Bank Details */}
                    <div className="mt_30">
                        <h4>Bank Details</h4>
                        <div className="gap_p">
                            <div className="w_25">
                                <h6>Account Holder Name</h6>
                                <p>Alice</p>
                            </div>
                            <div className="w_25">
                                <h6>Bank Account Number</h6>
                                <p>218978124</p>
                            </div>
                            <div className="w_25">
                                <h6>Bank Name</h6>
                                <p>PNB</p>
                            </div>
                            <div className="w_25">
                                <h6>Bank Branch Code</h6>
                                <p>6228</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt_30">
                        <h4>Vehicle Details</h4>
                        <div className="gap_p">
                            <div className="w_25">
                                <h6>Vehicle Number
                                </h6>
                                <p>1313</p>
                            </div>
                            <div className="w_25">
                                <h6>Vehicle Model
                                </h6>
                                <p>2023</p>
                            </div>
                            <div className="w_25">
                                <h6>Vehicle Color
                                </h6>
                                <p>Red</p>
                            </div>
                            <div className="w_25">
                                <h6>Registration Expiry
                                </h6>
                                <p>22-06-2026</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>


            {/* Loyalty Points */}
            <CustomTabPanel value={valueTabs} index={1}>
                <div className="cards view_page">
                    <div className="table_header">
                        <h2>Documents</h2>

                    </div>

                    <div className="gap_p" >
                        <div className="w_50">
                            <h6>Document Name
                            </h6>
                            <p>Name</p>
                        </div>
                        <div className="w_50">
                            <h6>Document Expiry
                            </h6>
                            <p>22-06-2027</p>
                        </div>

                        <div className="vew_img no_radius v2 w_50">
                            <h6>Front Image</h6>
                            <figure
                            >
                                <img
                                    src="/static/images/placeholder.png"
                                    alt="Driver"
                                />
                            </figure>
                        </div>
                        <div className="vew_img no_radius v2 w_50">
                            <h6>Back Image</h6>
                            <figure
                            >
                                <img
                                    src="/static/images/placeholder.png"
                                    alt="Driver"
                                />
                            </figure>
                        </div>
                    </div>
                </div>

            </CustomTabPanel>



            <VerificationModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
        </>
    );
};

export default ViewDriver;
